<!-- eslint-disable vue/html-indent -->
<template>
  <div class="fragment">

    <Head title="Dashboard" />

    <!-- Loading Overlay -->
    <loading-overlay :show="requestPending" message="Carregando dados..." />

    <div class="w-full flex items-center justify-between mb-6">
      <h1 class="text-3xl text-gray-777 font-roboto">Dashboard</h1>

      <button
        class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase ml-1 border-solid border-2 border-purple-100"
        @click="openFilters = true">
        <font-awesome-icon icon="fa-filter" class="text-purple text-sm mr-0 lg:mr-2" />
        Filtrar
      </button>
    </div>

    <aside
      class="fixed w-full duration-500 max-w-[400px] z-30 bg-violet-100 shadow-[0px_0px_30px] shadow-gray-400 top-0 bottom-0 px-4 pt-10 pb-10 overflow-y-auto"
      :class="{ '-right-full': !openFilters, 'right-0': openFilters }">
      <button arial-label="Botão fechar filtros" class="w-10 h-10 absolute top-4 right-4 text-gray-500"
        @click="openFilters = false">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>

      <h3 class="text-base font-bold">Pesquisa</h3>

      <select-input class="w-full mt-3" label="Região" v-model="filters.Admin.zone">
        <option value="">Selecione a região</option>
        <option v-for="zone in options.zones" :key="zone.id" :value="zone.name">{{ zone.name }}</option>
      </select-input>

      <select-input class="w-full mt-3" label="Estado" v-model="filters.Admin.state">
        <option value="">Selecione o Estado</option>
        <option v-for="state in options.states" :key="state" :value="state.state">{{ state.state }}</option>
      </select-input>

      <select-input class="w-full mt-3" label="Cidade" v-model="filters.Admin.city">
        <option value="">Selecione o Cidade</option>
        <option v-for="city in options.citys" :key="city" :value="city.city">{{ city.city }}</option>
      </select-input>

      <select-input class="w-full mt-3" label="Rede" v-model="filters.Admin.marketNetwork">
        <option value="">Selecione a Rede</option>

        <option v-for="marketNetwork in options.marketNetworks" :key="marketNetwork.id" :value="marketNetwork.id">
          {{ marketNetwork.name }}
        </option>
      </select-input>

      <select-input class="w-full mt-3" label="Loja" v-model="filters.Admin.market">
        <option value="">Selecione a Loja</option>
        <option v-for="market in options.markets" :key="market.id" :value="market.id">{{ market.unit }}</option>
      </select-input>

      <select-input class="w-full mt-3" label="Promotor" v-model="filters.Admin.promoter">
        <option value="">Selecione o promotor</option>
        <option v-for="promotor in options.promoters" :key="promotor" :value="promotor.id">{{ promotor.name }}</option>
      </select-input>

      <div class="flex justify-between gap-4">
        <div class="flex-1">
          <p class="mt-4">Data inicio</p>
          <date-input class="mt-3" v-model="filters.Admin.dateStart" />
        </div>

        <div class="flex-1">
          <p class="mt-4">Data final</p>
          <date-input class="mt-3" v-model="filters.Admin.dateEnd" />
        </div>
      </div>

      <select-input class="w-full mt-3" label="Status da atividade" v-model="filters.Admin.status">
        <option value="">Selecione o status</option>
        <option v-for="status in options.activitiesStatus" :key="status">{{ status }}</option>
      </select-input>

      <select-input class="w-full mt-3" label="Fornecedor" v-model="filters.Admin.provider">
        <option value="">Selecione fornecedor</option>
        <option v-for="provider in options.providers" :key="provider.id" :value="provider.id">{{ provider.name }}
        </option>
      </select-input>

      <p class="mt-4">Total de promotores</p>
      <div class="flex justify-between gap-4">
        <text-input type="number" min="0" class="mt-3" v-model="filters.Admin.promoterStartLimit" />
        <text-input type="number" min="1" class="mt-3" v-model="filters.Admin.promoterEndLimit" />
      </div>

      <div class="flex flex-shrink-0 flex-wrap items-center justify-start rounded-b-md mt-4">
        <loading-button @click="apllyFilters" :loading="requestPending"
          class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
          <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
          {{ requestPending ? 'Pesquisando...' : 'Pesquisar' }}
        </loading-button>
        <button @click="clearFilters" :disabled="requestPending"
          class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs leading-tight uppercase ml-1 border-solid border-2 border-purple-100 disabled:opacity-50 disabled:cursor-not-allowed">
          <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
          Limpar
        </button>
      </div>
    </aside>

    <div class="mt-4 flex flex-wrap justify-between">
      <purple-panel icon="fa-regular fa-star" title="Promotores" :value="dashbordData.totals.sales_promoter" />

      <purple-panel icon="fa-cart-shopping" title="Mercados" :value="dashbordData.totals.market_network" />

      <purple-panel icon="fa-regular fa-clipboard" title="Fornecedores" :value="dashbordData.totals.providers" />

      <purple-panel icon="fa-list-check" title="Atividades Executadas" :value="dashbordData.totals.activities" />
    </div>

    <div class="mt-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      <div class="bg-white col-start-1 col-span-2 shadow rounded-lg p-4 sm:p-4 xl:p-6 ">
        <div class="d-flex line-chart-select">
          <select class="form-select" v-model="selectedOption" @change="onUpdateLineChartIndex">
            <option v-for="(option, index) in lineChartOptions" :value="option.value" :key="index">{{ option.label }}
            </option>
          </select>
        </div>
        <line-chart :dataOptions="lineChartOptions[selectedIndex].value" :key="selectedIndex" />
      </div>

      <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6 ">
        <p class="text-center "><strong>Status das atividades</strong></p>
        <donut-chart :series="Object.values(dashbordData.statusActivities)"
          :labels="Object.keys(dashbordData.statusActivities)" />
      </div>

      <div class="white-panel-list">
        <div class="panel-wrapper">
          <div class="bg-white panel">
            <div class="bg-violet-100 flex items-center justify-center rounded-full h-[3.8rem] w-[3.8rem]">
              <span><font-awesome-icon icon="fa-list-check" class="text-purple-200 text-lg cursor-pointer" /></span>
            </div>
            <div class="panel-text">
              <h3 class="text-base font-poppins text-gray-600">Atividades Aprovadas</h3>
              <span class="text-xl sm:text-2xl leading-none font-semibold text-black">{{
                dashbordData.activities.approved }}</span>
            </div>
          </div>
        </div>
        <div class="panel-wrapper">
          <div class="bg-white panel">
            <div class="bg-violet-100 flex items-center justify-center rounded-full h-[3.8rem] w-[3.8rem]">
              <span><font-awesome-icon icon="fa-list-check" class="text-purple-200 text-lg cursor-pointer" /></span>
            </div>
            <div class="panel-text">
              <h3 class="text-base font-poppins text-gray-600">Atividades Invalidadas</h3>
              <span class="text-xl sm:text-2xl leading-none font-semibold text-black">{{
                dashbordData.activities.invalidated }}</span>
            </div>
          </div>
        </div>
        <div class="panel-wrapper">
          <div class="bg-white panel">
            <div class="bg-violet-100 flex items-center justify-center rounded-full h-[3.8rem] w-[3.8rem]">
              <span><font-awesome-icon icon="fa-list-check" class="text-purple-200 text-lg cursor-pointer" /></span>
            </div>
            <div class="panel-text">
              <h3 class="text-base font-poppins text-gray-600">Atividades Orientadas</h3>
              <span class="text-xl sm:text-2xl leading-none font-semibold text-black">{{
                dashbordData.activities.oriented }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6">
        <h3 class="text-lg font-semibold text-black">Mercados</h3>
        <data-table v-if="loadTable" v-model:columns="columns_market" route="market_network/list"
          no-data-label="Nenhum mercado cadastrado" no-result-label="Nenhum mercado cadastrado">
          <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm">Ver <font-awesome-icon
                  icon="fa-angle-right" class="text-white pr-2" /></span>
            </div>
          </template>
          <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm">Ver <font-awesome-icon
                  icon="fa-angle-right" class="text-white pr-2" /></span>
            </div>
          </template>
        </data-table>
      </div>


      <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6">
        <h3 class="text-lg font-semibold text-black">Promotores</h3>
        <data-table v-if="loadTable" v-model:columns="columns_promoter" route="sales_promoter/list"
          no-data-label="Nenhuma região cadastrada" no-result-label="Nenhuma região encontrada">
          <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm"
                @click.prevent="openModalConfig(row, 'sales_promoter')">Ver <font-awesome-icon icon="fa-angle-right"
                  class="text-white pr-2" /></span>
            </div>
          </template>
          <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm"
                @click.prevent="openModalConfig(row, 'sales_promoter')">Ver <font-awesome-icon icon="fa-angle-right"
                  class="text-white pr-2" /></span>
            </div>
          </template>
        </data-table>
      </div>

      <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6">
        <h3 class="text-lg font-semibold text-black">Fornecedores</h3>
        <data-table v-if="loadTable" v-model:columns="columns_provider" route="provider/list"
          no-data-label="Nenhuma região cadastrada" no-result-label="Nenhuma região encontrada">
          <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm"
                @click.prevent="openModalConfig(row, 'providers')">Ver <font-awesome-icon icon="fa-angle-right"
                  class="text-white pr-2" /></span>
            </div>
          </template>
          <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm"
                @click.prevent="openModalConfig(row, 'providers')">Ver <font-awesome-icon icon="fa-angle-right"
                  class="text-white pr-2" /></span>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <div class="mt-4 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4">
      <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6">
        <h3 class="text-lg font-semibold text-black">Sku</h3>
        <data-table v-if="loadTable" v-model:columns="columns_sku" route="brand/dashboard-list"
          no-data-label="Nenhum sku cadastrada" no-result-label="Nenhum sku encontrada">
        </data-table>
      </div>

      <div class="bg-white shadow rounded-lg p-4 sm:p-4 xl:p-6">
        <h3 class="text-lg font-semibold text-black">Rupturas</h3>
        <data-table v-if="loadTable" v-model:columns="columns_product" route="dashboard/list"
          no-data-label="Nenhuma região cadastrada" no-result-label="Nenhuma região encontrada">
          <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm"
                @click.prevent="openModalConfig(row, 'products')">Ver <font-awesome-icon icon="fa-angle-right"
                  class="text-white pr-2" /></span>
            </div>
          </template>
          <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid gap-4 ">
              <span class="bg-purple-100 text-white rounded p-2 cursor-pointer text-sm"
                @click.prevent="openModalConfig(row, 'products')">Ver <font-awesome-icon icon="fa-angle-right"
                  class="text-white pr-2" /></span>
            </div>
          </template>
        </data-table>
      </div>
    </div>


    <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true">
      <template #header="{ item }">
        <div class="text-gray-777 font-roboto uppercase">
          <span>{{ modalFields.title }}</span>
        </div>
      </template>
      <template #body>
        <form action="">
          <div class="flex" v-if="modalFields.type == 'providers'">
            <text-input v-model="modalFields.item.name" class="lg:pr-6 w-full lg:w-3/4" label="Nome" />
            <mask-input v-model="modalFields.item.cnpj" mask="##.###.###/####-##" class="lg:pr-6 w-full lg:w-3/4"
              label="CNPJ" />
          </div>

          <div class="flex flex-wrap mb-4 px-4" v-if="modalFields.type == 'sales_promoter'">
            <div class="lg:pr-6 w-full lg:w-3/4">
              <label>Dados do usuário</label>
            </div>
            <text-input v-model="modalFields.item.name" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Nome"
              required="true" />
            <text-input v-model="modalFields.item.email" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="E-mail"
              required="true" />
            <text-input v-model="modalFields.item.user_name" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Login"
              required="true" />
            <text-input v-model="modalFields.item.password" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Senha"
              required="true" />
            <div class="lg:pr-6 w-full lg:w-3/4 mt-6">
              <label>Dados pessoais</label>
            </div>
            <text-input v-model="modalFields.item.rg" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="RG" />
            <mask-input v-model="modalFields.item.cpf" mask="###.###.###-##" class="lg:pr-6 w-full lg:w-1/2 mt-6"
              label="CPF" />
            <text-input v-model="modalFields.item.mei" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="MEI" />
            <mask-input v-model="modalFields.item.cnpj" mask="##.###.###/####-##" class="lg:pr-6 w-full lg:w-1/2 mt-6"
              label="CNPJ" />

            <cep-input @updateAddress="onUpdateAddress" v-model="modalFields.item.address.postcode"
              class="lg:pr-6 w-full lg:w-2/6 mt-6" label="CEP" />
            <text-input v-model="modalFields.item.address.street" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Rua" />
            <text-input v-model="modalFields.item.address.number" class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Número" />
            <text-input v-model="modalFields.item.address.complement" class="lg:pr-6 w-full lg:w-1/2 mt-6"
              label="Complemento" />
            <text-input v-model="modalFields.item.address.neighborhood" class="lg:pr-6 w-full lg:w-1/4 mt-6"
              label="Bairro" />
            <select-input v-model="modalFields.item.address.state" class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Estado">
              <option :value="null" />
              <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
            </select-input>
            <text-input v-model="modalFields.item.address.city" class="lg:pr-6 w-full lg:w-1/3 mt-6" label="Cidade" />
            <div class="lg:pr-6 w-full lg:w-3/4 mt-6">
              <label>Dados bancários</label>
            </div>
            <text-input v-model="modalFields.item.bank" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Banco" />
            <text-input v-model="modalFields.item.bank_agency" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Agência" />
            <text-input v-model="modalFields.item.bank_account" class="lg:pr-6 w-full lg:w-1/2 mt-6"
              label="Conta bancária" />
            <text-input v-model="modalFields.item.pix" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Pix" />
          </div>

          <div class="flex flex-wrap mb-4 px-4" v-if="modalFields.type == 'products'">
            <text-input v-model="modalFields.item.brand" class="lg:pr-6 w-full lg:w-3/4" label="Marca"
              required="true" />
            <text-input v-model="modalFields.item.product" class="lg:pr-6 w-full lg:w-3/4" label="Produto"
              required="true" />
          </div>
        </form>
      </template>
      <template #footer>
        <button type="button"
          class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
          @click.prevent="closeModalConfig">Fechar</button>
      </template>
    </modal>
  </div>
</template>
<script>

import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

import { computed, watch } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import DataTable from '@/Shared/DataTable'
import LineChart from '@/Shared/LineChart'
import DonutChart from '@/Shared/DonutChart'
import SelectInput from '@/Shared/SelectInput.vue'
import Modal from '@/Shared/Modal'
import TextInput from '@/Shared/TextInput'
import MaskInput from '@/Shared/MaskInput'
import CepInput from '@/Shared/CepInput'
import DateInput from '@/Shared/DateInput'
import PurplePanel from '@/Shared/PurplePanel.vue'
import LoadingOverlay from '@/Shared/LoadingOverlay.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LineChart,
    DataTable,
    DonutChart,
    SelectInput,
    Modal,
    TextInput,
    MaskInput,
    CepInput,
    DateInput,
    PurplePanel,
    LoadingOverlay,
    LoadingButton,
  },
  layout: Layout,
  props: {
    totals: Object,
    activities: Object,
    graphic: Object,
    statusActivities: Object,
    options: Object,
  },
  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent('Admin', {
      zone: '',
      state: '',
      city: '',
      marketNetwork: '',
      market: '',
      promotor: '',
      dateStart: '',
      dateEnd: '',
      status: '',
      provider: '',
      promoter: '',
      promoterStartLimit: 0,
      promoterEndLimit: 10,
    })

    const clearFilters = () => clearFiltersComponent('Admin', {
      zone: '',
      state: '',
      city: '',
      marketNetwork: '',
      market: '',
      promotor: '',
      dateStart: '',
      dateEnd: '',
      status: '',
      provider: '',
      promoter: '',
      promoterStartLimit: 0,
      promoterEndLimit: 10,
    })
    const getFilters = () => getFiltersComponent('Admin')

    const user = computed(() => usePage().props.value.auth.user)
    return {
      user,
      loadTable: true,
      getFilters,
      clearFilters,
      filters: filtersStore.filters,
      columns_market: [
        {
          uniqid: 'name',
          label: 'Nome da rede',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
          format: (val, row) => `${row.name}`,
        },
        {
          uniqid: 'totalMarket',
          label: 'N° de lojas',
          field: 'market_count',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
        },
      ],

      columns_promoter: [
        {
          uniqid: 'name',
          label: 'Promotor',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4 text-xs uppercase',
        },
      ],
      columns_provider: [
        {
          uniqid: 'name',
          label: 'Fornecedor',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
          format: (val, row) => `${row.name}`,
        },
        {
          uniqid: 'totalBrand',
          label: 'N° de marcas',
          field: 'brand_count',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4 text-xs uppercase',
        },
      ],
      columns_sku: [
        {
          uniqid: 'name',
          label: 'Nome da marca',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
          format: (val, row) => `${row.name}`,
        },
        {
          uniqid: 'totalProduct',
          label: 'Total de produtos',
          field: 'totalProduct',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
        },
      ],
      columns_product: [
        {
          uniqid: 'brand',
          label: 'Marca',
          field: 'brand',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
        },
        {
          uniqid: 'product',
          label: 'Produto',
          field: 'product',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left text-xs uppercase',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4 text-xs uppercase',
        },
      ],
      modalFields: {
        title: '',
        type: '',
        item: {},
      },
    }
  },
  data() {
    return {
      selectedOption: 0,
      selectedIndex: 0,
      openFilters: false,
      requestPending: false,
      dashbordData: {
        totals: this.totals,
        activities: this.activities,
        graphic: this.graphic,
        statusActivities: this.statusActivities,
      },
      lineChartOptions: [
        {
          label: 'Atividades Executadas ',
          value: this.graphic?.activities_performed,
        },
        {
          label: 'Fornecedores Cadastrados',
          value: this.graphic?.providers_registered,
        },
        {
          label: 'Mercados Cadastrados',
          value: this.graphic?.markets_registered,
        },
        {
          label: 'Total de Promotores',
          value: this.graphic?.sales_promoter_registered,
        },
      ],
    }
  },

  mounted() {
    // this.apllyFilters()
  },

  computed: {
    getQuery() {
      return Object.entries(this.getFilters()).map(([key, val]) => `search[${key}]=${val}`).join('&')
    },
  },

  methods: {
    onUpdateLineChartIndex() {
      this.selectedIndex = this.lineChartOptions.findIndex(options => options.value === this.selectedOption)
    },
    clearFilters() {
      this.clearFilters()
      this.apllyFilters()
    },
    apllyFilters: async function () {
      this.requestPending = true
      const query = '/filter?' + this.getQuery
      this.dashbordData = await (await fetch(query)).json()
      this.openFilters = false
      this.requestPending = false
    },
    openModalConfig(item, option) {
      if (option == 'providers') {
        this.modalFields.title = "Fornecedor"
      } else if (option == 'sales_promoter') {
        this.modalFields.title = "Promotores"
      }
      this.modalFields.type = option,
        this.modalFields.item = item

      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },
  },
}
</script>

<style scoped>
.line-chart-select {
  width: 50%;
}

.purple-panels-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.purple-panels-list .panel-wrapper {
  width: 25%;
  padding: 0 10px;
}

.purple-panels-list .panel-wrapper:first-child {
  padding-left: 0;
}

.purple-panels-list .panel-wrapper:last-child {
  padding-right: 0;
}

.white-panel-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.panel {
  border-radius: 6px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  padding: 1.25rem;
  box-shadow: 0px 1px 4px rgba(21, 34, 50, 0.078);
}

.badge {
  min-width: 60px;
  min-height: 60px;
  max-width: 30%;
}

.panel-text {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  max-width: 65%;
  margin-left: 10px;
}

@media screen and (max-width: 1024px) {
  .purple-panels-list .panel-wrapper {
    width: 50% !important;
    padding: 0.5rem !important;
  }
}
</style>